import * as React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import MenuIcon from 'material-ui-icons/Menu';
import {IconButton} from 'material-ui';
import HeaderTopBar from './header_bar';
import styles from './style/side_menu';
import {connect} from 'react-redux';
import {toggleSideBar} from './actions';
import {withStyles} from 'material-ui/styles';

class MainAppBar extends React.Component {

    handleDrawerOpen = () => {
        this.props.toggleSideBar(true);
    };

    render() {

        const {classes, appBar, toolBar, iconButton} = this.props;

        return (
            <AppBar className={appBar}>
                <Toolbar>
                    <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={this.handleDrawerOpen}
                            className={iconButton}>
                        <MenuIcon />
                    </IconButton>
                    <div className={toolBar}>
                        <div className="logo">
                            <img src={process.env.PUBLIC_URL + '/assets/logo-inverted.svg'} alt="logo"/>
                        </div>
                    </div>
                    <div className={classes.topBarUserName}>
                        <div className="floatRight">
                            <div variant="caption" className={classes.topBarUserNameInfo}>
                                Logged in as:
                            </div>
                        </div>
                        <div>
                            <div variant="subheading" className={classes.topBarUserNameText}>
                                {this.props.userName}
                            </div>
                        </div>
                    </div>
                    <HeaderTopBar />
                </Toolbar>
            </AppBar>
        )
    }
}

const mapStateToProps = state => ({
    sidebarOpen: state.layout.sidebarOpen,
    userName: state.auth.user.name,
});

export default connect(mapStateToProps, {toggleSideBar})(
    withStyles(styles)(MainAppBar)
);



// WEBPACK FOOTER //
// ./src/containers/layout/app_bar.js